import type { ReactNode } from 'react';

export const symbol_mobile_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m523-450-32 32q-9 9-9 21t9 21q9 9 21.5 9t21.5-9l83-83q5-5 7-10.13 2-5.14 2-11 0-5.87-2-10.87-2-5-7-10l-84-84q-9-9-21.2-9-12.19 0-20.8 9-9 9-8.5 21t8.5 21l32 33H380q-24.75 0-42.37 17.62Q320-474.75 320-450v90q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-90h143ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Z"
		/>
	</svg>
);
